<template>
  <div class="contai_h">
    <div class="con_top">
      <el-radio-group v-model="types">
        <el-radio-button label="民品"></el-radio-button>
        <el-radio-button label="汽车"></el-radio-button>
        <el-radio-button label="房产"></el-radio-button>
      </el-radio-group>

      <div class="con_query">
        <Query @child-event="childData" :message="types"></Query>
      </div>
    </div>

    <div class="filtrate_sx">
      <!-- 筛选数据模块 -->
      <div class="rows_header">
        <span>
          查找日期：
          <el-date-picker
            v-model="DateInputSearch"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </span>

        <span>
          <el-tooltip
            class="item"
            effect="dark"
            content="请输入综合费大于等于的值"
            placement="top"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>

          <!-- @mousemove="Mouse" -->

          累计综合费：
          <el-input
            placeholder="请输入综合费金额,大于等于"
            v-model="PriceInput"
            clearable
            class="zhf_input"
          >
          </el-input>
          <el-button type="primary" @click="SearchData">综合费搜索</el-button>
        </span>

        <span>
          <el-tooltip
            class="item"
            effect="dark"
            content="请输入典当单价小于等于的值"
            placement="top"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
          典当单价:
          <el-input
            placeholder="请输入单价,小于等于"
            v-model="PriceDj"
            clearable
            class="zhf_input"
          >
          </el-input>
          <el-button type="primary" @click="SearchDj">典当单价搜索</el-button>
        </span>
        <!-- <span>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="1000"
            :total="pageNum"
            @current-change="currentData"
          >
          </el-pagination>
        </span> -->
        <span>
          <download-excel
            class="export-excel-wrapper"
            :data="items"
            :fields="json_fields"
            :name="
              isY == 1
                ? '累计综合费大于等于' + PriceInput
                : '典当单价小于等于' + PriceDj + '.xls'
            "
          >
            <el-button type="primary" size="small" @click="ExportData"
              >导出表格</el-button
            >
          </download-excel>
        </span>

        <span class="jls">记录数:{{ Nums }}</span>
      </div>
    </div>

    <div class="cont_tabs">
      <div class="ces">
        <div class="bj">
          <el-button-group>
            <el-button type="primary" round @click="ZData('在当')">在当</el-button>
            <el-button type="primary" round @click="ZData('赎回')">赎回</el-button>
            <el-button type="primary" round @click="ZData('绝当')">绝当</el-button>
          </el-button-group>
        </div>
        <div>
          <span>没有颜色代表正常在当业务</span>
          <span class="blue">青色代表赎回业务</span>
          <span class="yus">黄色代表逾期业务</span>
          <span class="jus">红色代表绝当业务</span>
        </div>
      </div>
      <el-table
        :data="items"
        border
        style="width: 100%"
        height="69vh"
        :row-class-name="tableRowClassName"
        v-loading="loading"
        element-loading-text="数据加载中..."
      >
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row._id)" type="text" size="small"
              >查看</el-button
            >
            <el-button
              @click="handlexu(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.state !== '赎回'"
              >续当</el-button
            >
            <el-button
              @click="handleshu(scope.row._id)"
              type="text"
              size="small"
              v-if="scope.row.state !== '赎回'"
              >赎回</el-button
            >
            <el-button @click="handledelete(scope.row._id)" type="text" size="small"
              >删除</el-button
            >
            <el-button @click="sendSms(scope.row)" type="text" size="small"
              >发短信通知</el-button
            >
            <el-button
              @click="checkFq(scope.row)"
              type="text"
              size="small"
              v-if="scope.row.command"
              >查看分期</el-button
            >

            <el-button @click="Prints(scope.row)" type="text" size="small"
              >补打当票</el-button
            >
          </template>
        </el-table-column>

        <el-table-column prop="deta" label="建当日期" width="160">
          <template slot-scope="scope">
            {{ scope.row.deta || scope.row.dates || scope.row.CreateDate }}
          </template>
        </el-table-column>
        <el-table-column prop="ticketnumber" label="票号" width="130">
          <template slot-scope="scope">
            {{ scope.row.ticketnumber || scope.row.piaonum || scope.row.Piaonumber }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="80">
          <template slot-scope="scope">
            {{ scope.row.name || scope.row.Dhname }}
          </template>
        </el-table-column>
        <el-table-column prop="telnumber" label="电话" width="130">
          <template slot-scope="scope">
            {{ scope.row.telnumber || scope.row.tel }}
          </template>
        </el-table-column>
        <el-table-column prop="itemname" label="物品类型" width="100">
          <template slot-scope="scope">
            {{ scope.row.itemname || scope.row.radios || "房产" }}
          </template>
        </el-table-column>
        <el-table-column prop="objname" label="物品名字" width="130">
          <template slot-scope="scope">
            {{
              types == "民品"
                ? scope.row.objname
                : types == "汽车"
                ? "汽车-" + scope.row.plateNumber
                : "房产-" + scope.row.Fcaddres
            }}
            <!-- {{scope.row.objname || `汽车-${scope.row.plateNumber}` || `房产-${scope.row.Fcaddres}`}} -->
          </template>
        </el-table-column>
        <el-table-column prop="number" label="数量" width="60">
          <template slot-scope="scope">
            {{ scope.row.number || "1" }}
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="重量/g" width="120">
          <template slot-scope="scope">
            {{ scope.row.weight || "无" }}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="典当金额/元" width="100">
          <template slot-scope="scope">
            {{ scope.row.price || scope.row.sum || scope.row.Ddedquota }}
            <!-- {{types == "民品" ? scope.row.price: scope.row.sum}} -->
          </template>
        </el-table-column>
        <el-table-column prop="price" label="典当单价/元" width="100">
          <template slot-scope="scope">
            {{ (scope.row.price / scope.row.weight).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="startdate" label="开始日期" width="120">
          <template slot-scope="scope">
            {{ scope.row.startdate || scope.row.startDate || scope.row.DdqxStartDate }}
          </template>
        </el-table-column>
        <el-table-column prop="enddate" label="结束日期" width="120">
          <template slot-scope="scope">
            {{ scope.row.enddate || scope.row.DateClosed || scope.row.DdqxEndDate }}
          </template>
        </el-table-column>
        <el-table-column prop="mode" label="支付方式" width="120">
          <template slot-scope="scope">
            {{ scope.row.mode || scope.row.KhBank || "/" }}
          </template>
        </el-table-column>
        <el-table-column prop="compre" label="是否支付第一期综合费" width="120">
          <template slot-scope="scope">
            {{ scope.row.compre || "未接入小程序" }}
          </template>
        </el-table-column>
        <el-table-column prop="cost" label="累计典当综合费" width="110">
          <!-- <template slot-scope="scope">
            {{ scope.row.compre || scope.row.comprehensive }}
          </template> -->
        </el-table-column>
        <el-table-column prop="days" label="典当天数" width="90">
          <template slot-scope="scope">
            {{ scope.row.days || scope.row.det }}
          </template>
        </el-table-column>
        <el-table-column prop="agent" label="经办人" width="100">
          <template slot-scope="scope">
            {{ scope.row.agent || scope.row.CreateUser }}
          </template>
        </el-table-column>
        <el-table-column prop="review" label="复核" width="100">
          <template slot-scope="scope">
            {{ scope.row.review || scope.row.reviewer || scope.row.Review }}
          </template>
        </el-table-column>
        <el-table-column prop="finance" label="财务" width="100">
          <template slot-scope="scope">
            {{ scope.row.finance || scope.row.Finance }}
          </template>
        </el-table-column>
        <el-table-column prop="remit" label="批款人" width="100"> </el-table-column>
      </el-table>
      <!-- 民品续当弹窗设置 -->
      <el-dialog
        title="续当操作："
        :visible.sync="dialogFormVisible"
        width="50%"
        :before-close="dialogFormqux"
      >
        <el-form :model="form">
          <el-form-item label="续当票号：" :label-width="formLabelWidth">
            {{ xudata.ticketnumber }}
          </el-form-item>
          <el-form-item label="典当状态：" :label-width="formLabelWidth">
            {{ xstas === true ? "逾期" : "在当" }}
          </el-form-item>
          <el-form-item label="原到期日期：" :label-width="formLabelWidth">
            {{ xudata.enddate }}
          </el-form-item>
          <el-form-item label="典当金额：" :label-width="formLabelWidth">
            {{ xudata.price + "元" }}
          </el-form-item>
          <el-form-item label="选择续当日期：" :label-width="formLabelWidth">
            <div class="block">
              <el-date-picker
                v-model="datevalue"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                @change="days"
              >
              </el-date-picker>
              /** 手动选择当期外的日期时，综合费和利息需要自行计算
              综合费小数采用四舍五入**/
            </div>
          </el-form-item>
          <el-form-item label="续当周期：" :label-width="formLabelWidth">
            <div class="cons_o">
              <el-button-group>
                <el-button type="primary" @click="five(xudata.enddate)" :disabled="xstas"
                  >5天</el-button
                >
                <el-button type="primary" @click="seven(xudata.enddate)" :disabled="xstas"
                  >7天</el-button
                >
                <el-button type="primary" @click="thfive(xudata.enddate)">15天</el-button>
                <el-button type="primary" @click="twufive(xudata.enddate)"
                  >25天</el-button
                >
                <el-button type="primary" @click="thre(xudata.enddate)">30天</el-button>
              </el-button-group>
            </div>
          </el-form-item>
          <el-form-item label="选择的续当天数：" :label-width="formLabelWidth">
            {{ xzdate + "天" }}
          </el-form-item>
          <el-form-item label="续当综合费：" :label-width="formLabelWidth">
            <el-input
              clearable
              v-model="form.pris"
              autocomplete="off"
              class="cont_input"
            ></el-input>
            <span>（本金*会员费率/非会员费率）</span>
          </el-form-item>
          <el-form-item label="典当利息：" :label-width="formLabelWidth">
            <el-input
              clearable
              v-model="lx"
              autocomplete="off"
              class="cont_input"
            ></el-input>
            <span>（本金*典当利息）</span>
          </el-form-item>

          <el-form-item label="逾期天数：" :label-width="formLabelWidth" v-if="xstas">
            {{ ytdy }} 天
          </el-form-item>
          <el-form-item label="操作日期：" :label-width="formLabelWidth">
            <el-date-picker
              v-model="czDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="续当操作人：" :label-width="formLabelWidth">
            {{ name }}
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormqux">取 消</el-button>
          <el-button type="primary" @click="dialogFormend">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 弹窗设置结束 -->

      <!-- 补打当票弹窗 -->
      <el-dialog
        title="补打当票"
        :visible.sync="dialogPrint"
        width="60%"
        :before-close="handleClosePrint"
      >
        <ReprintBill :ReprintData="PrintData"></ReprintBill>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClosePrint">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 重新提交评估 -->
      <!-- <el-dialog
        title="重新评估"
        :visible.sync="dialogVpg"
        width="40%"
        :before-close="dialogVpgClose"
        >
         <div class="car_conts">
            <span>票号：{{xudetais.piaonum}}</span>
            <span>车牌号：{{xudetais.plateNumber}}</span>
            <span>当户：{{xudetais.name}}</span>
            <span>上次评估金额：{{xudetais.overallValuation}}</span>
            <span>重新评估：<el-input
              placeholder="请输入重新评估价格"
              type="number"
              v-model="pguInput"
              style="width: 20%"
              clearable
            /></span>
            <span>评估人：{{username}}</span>
            <span>重新评估日期：{{deta}}</span>
            <span class="text_car">**汽车每次续当都需要重新评估当物当前价值，可以和上次评估价格一样</span>
         </div>
        
       <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVpgClose">取 消</el-button>
          <el-button type="primary" @click="dialogCxgj(xudetais)">提交评估</el-button>
      </span>
      </el-dialog> -->

      <!-- 汽车续当弹窗 -->
      <!-- <el-dialog title="续当操作:" :visible.sync="dialogTabs" width="40%">
        <div class="con_xu">
          <span>当户姓名： {{ xudetais.name }}</span>
          <span>续当当票： {{ xudetais.piaonum }}</span>
          <span>典当状态： {{ states == true ?"逾期":"在当"}}</span>
          <span v-if="states==true">逾期天数：{{yday + '天'}}</span>
          <span>原到期日期： {{ xudetais.DateClosed }}</span>
          <span>典当金额： {{ xudetais.sum }}</span>
          <span>选择续当日期:
            <el-date-picker
              v-model="xudetavalue"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @change="days">
            </el-date-picker>
          </span>
          <span>
            续当周期:
            <el-button-group>
              <el-button type="primary" @click="zseven" disabled>7天</el-button>
              <el-button type="primary" @click="zfive" disabled>15天</el-button>
              <el-button type="primary" @click="zthre">30天</el-button>
            </el-button-group>
          </span>
           <span>选择的续当天数：{{day}}</span>

          <span>
            续当综合费:
            <el-input
              placeholder="请输入续当综合费"
              v-model="inpus"
              style="width: 30%"
              clearable
            />
          </span>
           <span
            >典当利息:
            <el-input
              placeholder="请输入续当利息"
              v-model="lInpus"
              style="width: 30%"
              clearable
            />
          </span>
          <span>续当操作人: {{ username }}</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="rest">取 消</el-button>
          <el-button type="primary" @click="dialogEnd">确 定</el-button>
        </span>
      </el-dialog> -->

      <!-- 赎回弹窗 -->
      <el-dialog
        title="赎回操作："
        :visible.sync="dialogVshus"
        width="50%"
        :before-close="dialogFormqux"
      >
        <div class="ctens" v-for="item in sitems" :key="item._id">
          <span>典当状态：{{ xstas === true ? "逾期" : "在当" }}</span>
          <span>票号：{{ item.ticketnumber }}</span>
          <span>物品名称：{{ item.objname }}</span>
          <span v-if="xstas">逾期天数：{{ ytdy + "天" }}</span>
          <span>典当金额：{{ item.price + "元" }}</span>
          <span v-if="xstas">逾期赎当综合息费：{{ xupri + "元" }}</span>
          <!-- <span v-if="xstas">逾期罚息：{{ pena + '元'}}</span> -->
          <span
            >操作日期：
            <el-date-picker
              v-model="czDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </span>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVshus = false">取 消</el-button>
          <el-button type="primary" @click="shuEnd(sitems)">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 查看分期信息弹窗 -->

      <el-dialog
        title="查看分期"
        :visible.sync="dialogVisible1"
        width="60%"
        :before-close="handleClose"
      >
        <!-- <Separate></Separate> -->
        <CheckPlan
          :Data="detail"
          id="printPdf"
          :token="ACCESS_TOKEN"
          :env="userData.env"
        ></CheckPlan>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import Query from "@/components/Query.vue";
import CheckPlan from "@/components/cars/CheckPlan.vue";
import ReprintBill from "@/components/reprintBill/ReprintBill.vue";
export default {
  name: "kan",

  data() {
    return {
      ACCESS_TOKEN: "", //ACCESS_TOKEN
      token: "", //token令牌
      id: "", //被点击续当的id
      items: [], //查找的数据
      dialogFormVisible: false, //默认不打开续当弹窗
      dialogVshus: false, //赎回弹窗默认不打开
      dialogVpg: false, //汽车续当
      dialogVpgClose: false, //汽车续当关闭
      form: {
        pris: 0, //续当费用
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "150px",
      xudata: "", //被点击续当的数据
      name: "", //当前登录的用户的名字
      datevalue: "", //选择的日期
      ydays: "", //原来的典当天数
      ypris: "", //原来的典当金额
      xdate: "", //续当后的总典当天数
      xzdate: 0, //选择的续当天数
      zonpri: "", //计算好的总典当综合费
      deta: "", //今天的日期
      day: "", //逾期鉴定日

      xstas: false, //续当状态
      ytdy: 0, //逾期天数
      pena: 0, ////逾期罚息
      rece: 0, //实收

      sitems: "", //被点击要赎回的全部数据
      xupri: 0, //逾期未付综合费
      lx: 0, //典当利息

      czDate: "", //操作日期

      yspri: 0, //应收

      types: "民品", //查询类型

      xudetais: "", //续当的点击数据

      dialogVisible1: false, //默认不打开

      detail: {}, //传给子组件的参数

      dialogPrint: false, //补打当票弹窗

      PrintData: {}, // 补打当票数据

      userData: {
        env: "",
      },

      DateInputSearch: "", //日期搜索
      PriceInput: "", //典当综合费
      PriceDj: "", //典当单价
      Nums: 0, //查找记录数
      isY: 0, //当前页面的是哪个页面  1 ：综合费   2 ：典当单价
      pageNum: 0, //总页码
      loading: false, // loding

      Ns: [],

      json_fields: {
        建当日期: "deta",
        票号: "ticketnumber",
        当户: "name",
        电话: "telnumber",
        物品名称: "objname",
        "典当金额/元": "price",
        "重量/g": "weight",
        累计综合费: "cost",
        典当单价: "unitpricea",
        典当天数: "days",
      },
      FilterItemData: [],
    };
  },

  components: {
    Query,
    CheckPlan,
    ReprintBill,
  },

  methods: {
    days(e) {
      if (e == null) {
        return (this.xzdate = 0), (this.form.pris = 0), (this.lx = 0), (this.pena = 0);
      }
      // 当手动选择日期时，触发 拿到当前选择的日期减去开始日期，得到的典当天数
      (this.xdate = dayjs(e).diff(dayjs(this.xudata.startdate), "day")),
        //当手动选择日期时，触发，拿到手动选择日期的天数
        (this.xzdate = dayjs(e).diff(dayjs(this.xudata.enddate), "day")),
        (this.form.pris = 0),
        (this.pena = 0),
        (this.lx = 0),
        (this.yspri = "手动选日期无法计算应收");
    },

    childData(data) {
      // console.log(data)
      // if(data == "房产"){
      //   return  this.$message.error('未开通房产业务，查点其他的吧');
      // }
      this.items = data;
    },

    // 筛选颜色
    tableRowClassName({ row }) {
      // if(row.)
      // console.log(row.enddate,row)
      if (row.enddate !== undefined) {
        if (row.enddate >= this.day && row.enddate < this.deta && row.state == "在当") {
          return "success-row";
        }

        //绝当的订单
        if ((row.enddate < this.day && row.state !== "赎回") || row.state == "绝当") {
          return "warning-row";
        }

        //赎回的订单
        if (row.state == "赎回") {
          return "sudatas-row";
        }

        return "";
      } else {
        if (
          row.DateClosed >= this.day &&
          row.DateClosed < this.deta &&
          row.state == "在当"
        ) {
          return "success-row";
        }

        //绝当的订单
        if ((row.DateClosed < this.day && row.state !== "赎当") || row.state == "绝当") {
          return "warning-row";
        }

        //赎回的订单
        if (row.state == "赎当") {
          return "sudatas-row";
        }

        return "";
      }
    },
    // 查看订单
    handleClick(e) {
      if (this.types == "民品") {
        this.$router.push({ path: "/details", query: { id: e } });
      } else {
        this.$router.push({ path: "/Car/CarDetail", query: { id: e } });
      }
    },

    //续当操作
    handlexu(event) {
      let token = sessionStorage.getItem("token");

      if (token == "caddGl002") {
        if (this.types == "民品") {
          //民品续当
          //请求数据
          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: 'db.collection("add_data").doc("' + event._id + '").get()',
            })
            .then((res) => {
              res.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
              });
              this.xudata = res.data.data[0]; //被点击的数据
              this.ydays = res.data.data[0].days; //被点击的数据的典当天数
              this.ypris = res.data.data[0].cost; //被点击的数据的往期典当综合费

              //判断是否支付第一期典当综合费
              if (!("compre" in res.data.data[0]) || res.data.data[0].compre == "是") {
                //打开弹窗设置
                this.dialogFormVisible = !this.dialogFormVisible;
                //判断是否为逾期
                if (res.data.data[0].enddate < this.deta) {
                  return (
                    (this.xstas = true),
                    (this.ytdy = dayjs(this.deta).diff(
                      dayjs(res.data.data[0].enddate),
                      "day"
                    ))
                  );
                }
                this.xstas = false;
              } else {
                this.$alert(
                  "该当户未支付第一期典当综合费，不可续当，请提醒当户支付综合费后，才可续赎当操作",
                  "温馨提示",
                  {
                    confirmButtonText: "确定",
                  }
                );
              }
            });
        } else {
          //汽车续当
          this.$alert("暂不支持，汽车续当请在汽车业务里操作", "提示", {
            confirmButtonText: "确定",
          });
        }
      } else {
        this.$alert("对不起，您没有该权限", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
    //点击确认续当事件
    dialogFormend() {
      //如果典当综合费输入框的值为空，不可续当
      if (this.form.pris == "") {
        return this.$message.error("典当综合费不能为空哦");
      }
      //总的典当综合服务费金额
      this.zonpri = Math.round(
        Number(this.ypris) + Number(this.form.pris) + Number(this.lx)
      );

      this.rece = Number(this.form.pris) + Number(this.lx); //实收
      if (this.xudata.enddate > this.day && this.xudata.enddate < this.deta) {
        //逾期 点击确定续当执行的方法
        setTimeout(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("add_data").doc("' +
                this.id +
                '").update({data:{enddate:"' +
                this.datevalue +
                '",days:"' +
                this.xdate +
                '",cost:"' +
                this.zonpri +
                '"}})',
            })
            .then((rec) => {
              if (rec.data.errcode === 0) {
                this.$notify({
                  title: "续当成功",
                  message: "恭喜你，该订单已续当成功",
                  type: "success",
                });
                this.sendtui();
                //续当成功执行的方法
                this.yover();
              } else {
                this.$notify({
                  title: "续当失败",
                  message: "请刷新页面在操作或检查输入的信息是否有误",
                  type: "warning",
                });
                setTimeout(() => {
                  this.$router.go(0);
                }, 1500);
              }
            });
        }, 800);
      } else {
        //正常续当点击  确定续当执行的方法
        setTimeout(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("add_data").doc("' +
                this.id +
                '").update({data:{enddate:"' +
                this.datevalue +
                '",days:"' +
                this.xdate +
                '",cost:"' +
                this.zonpri +
                '"}})',
            })
            .then((rec) => {
              if (rec.data.errcode === 0) {
                this.$notify({
                  title: "续当成功",
                  message: "恭喜你，该订单已续当成功",
                  type: "success",
                });
                this.sendtui();
                //续当成功执行的方法
                this.yover();
              } else {
                this.$notify({
                  title: "续当失败",
                  message: "请刷新页面在操作或检查输入的信息是否有误",
                  type: "warning",
                });
                setTimeout(() => {
                  this.$router.go(0);
                }, 1500);
              }
            });
        }, 800);
      }
    },
    //续当成功给当户发推送
    sendtui() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({idcard:"${this.xudata.cardnumber}"}).get()`,
        })
        .then((ruser) => {
          ruser.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          //发公众号x续当成功模板消息
          this.axios.post(
            "/api/cgi-bin/message/wxopen/template/uniform_send?access_token=" +
              this.ACCESS_TOKEN,
            {
              touser: ruser.data.data[0]._openid,
              mp_template_msg: {
                appid: "wx9019ccce538953c5",
                template_id: "e5XTJ6oMC5lg6dpTzOkqqn7UQe21pcDDyNI91OwZ8Qw",
                url: "http://weixin.qq.com",
                miniprogram: {
                  appid: "wx153c354afba9df6f",
                  pagepath: "pages/offline/offlines/index",
                },
                data: {
                  first: {
                    value: `尊敬的${this.xudata.name}先生/女士，您以下典当业务已续当成功。`,
                    color: "#173177",
                  },
                  keyword1: {
                    value: this.xudata.ticketnumber,
                    color: "#173177",
                  },
                  keyword2: {
                    value: this.xudata.objname,
                    color: "#173177",
                  },
                  keyword3: {
                    value: this.xzdate + "天",
                    color: "#173177",
                  },
                  keyword4: {
                    value: this.datevalue,
                    color: "#173177",
                  },
                  remark: {
                    value:
                      "欢迎再次使用微信续当，无需到店24小时在线续赎，经常会有优惠券可以领取哦！",
                    color: "#173177",
                  },
                },
              },
            }
          );
        });
    },
    //续当成功执行的事件
    yover() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{name:"${
            this.xudata.name
          }",xuday:"${this.czDate}",cardnumber:"${this.xudata.cardnumber}",itemname:"${
            this.xudata.objname
          }",
            ticketnumber:"${this.xudata.ticketnumber}",telnumber:"${
            this.xudata.telnumber
          }",startdate:"${this.xudata.startdate}",xupri:"${this.form.pris}",
            enddate:"${this.datevalue}",dday:"${this.xzdate}",xuname:"${
            this.name
          }",overdate:"${dayjs(this.xudata.enddate)
            .add(1, "day")
            .format("YYYY-MM-DD")}",ytdy:"${this.ytdy}",pena:"${
            this.pena
          }",stas:"续当",rece:"${this.rece}",yspri:"${this.rece}",pri:"${
            this.xudata.price
          }",lx:"${this.lx}",yspri:"${
            this.yspri
          }",couqons:"线下不适用",couqonmoney:"0"}})`,
        })
        .then(() => {
          setTimeout(() => {
            this.$router.go(0);
          }, 1500);
        });
    },
    //赎回成功执行的事件
    sover() {
      this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{name:"${this.sitems[0].name}",xuday:"${this.czDate}",itemname:"${this.sitems[0].objname}",ticketnumber:"${this.sitems[0].ticketnumber}",
          telnumber:"${this.sitems[0].telnumber}",startdate:"${this.sitems[0].startdate}",xupri:"${this.xupri}",enddate:"${this.sitems[0].enddate}",dday:"0",xuname:"${this.name}",overdate:"${this.sitems[0].startdate}",ytdy:"${this.ytdy}",pena:"${this.pena}",rece:"${this.rece}",yspri:"${this.rece}",stas:"赎当",pri:"${this.sitems[0].price}",lx:"${this.lx}",couqons:"线下不适用",couqonmoney:"0"}})`,
        })
        .then((sc) => {
          if (sc.data.errcode == 0) {
            setTimeout(() => {
              this.$router.go(0);
            }, 1500);
          }
        });
    },
    //点击取消续当的事件
    dialogFormqux() {
      (this.dialogFormVisible = false),
        (this.datevalue = ""),
        (this.xdate = ""),
        (this.xzdate = 0),
        (this.form.pris = 0),
        (this.lx = 0),
        (this.pena = 0),
        (this.czDate = ""),
        (this.yspri = 0);
    },
    //赎回操作
    handleshu(e) {
      this.id = e;
      //通过id查找到该数据
      let token = sessionStorage.getItem("token");

      if (token == "caddGl002") {
        if (this.types == "民品") {
          this.axios
            .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("add_data").doc("${this.id}").get()`,
            })
            .then((refs) => {
              refs.data.data.forEach((element, index, array) => {
                array[index] = JSON.parse(element);
                this.sitems = refs.data.data;
              });
              // 判断是否支付第一期典当综合费
              if (!("compre" in refs.data.data[0]) || refs.data.data[0].compre == "是") {
                this.dialogVshus = !this.dialogVshus;
                //判断是否逾期赎回
                if (refs.data.data[0].enddate < this.deta) {
                  //逾期赎回
                  return (
                    (this.xstas = true),
                    (this.ytdy = dayjs(this.deta).diff(
                      dayjs(refs.data.data[0].enddate),
                      "day"
                    )),
                    // (this.pena = Math.round(refs.data.data[0].price * 0.0075)),  //逾期赎回罚息
                    (this.xupri = Math.trunc(refs.data.data[0].price * 0.007)), //逾期赎回综合息费
                    (this.rece = Math.trunc(
                      Number(refs.data.data[0].price) +
                        Number(refs.data.data[0].price * 0.007) //实付金额
                    ))
                  );
                }
                this.xstas = false;
                this.rece = Math.trunc(Number(this.sitems[0].price));
              } else {
                this.$alert(
                  "该当户未支付第一期典当综合费，不可续当，请提醒当户支付综合费后，才可续赎当操作",
                  "温馨提示",
                  {
                    confirmButtonText: "确定",
                  }
                );
              }
            });
        } else {
          //汽车赎回
          this.$alert("暂不支持，请在汽车业务里操作", "提示", {
            confirmButtonText: "确定",
          });
        }
      } else {
        this.$alert("对不起，您没有该权限", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
    //赎回确定按钮
    shuEnd() {
      //判断登录的是不是管理员账号

      this.$confirm("确定要赎回这个业务吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query:
                'db.collection("add_data").doc("' +
                this.id +
                '").update({data:{state:"赎回"}})',
            })
            .then((re) => {
              if (re.data.errcode == 0) {
                this.sover();
                this.$message({
                  type: "success",
                  message: "赎回成功",
                });
                setTimeout(() => {
                  this.$router.go(0);
                }, 1500);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //删除业务方法
    removes(event, id) {
      this.$confirm("确定要删除这个业务吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("${event}").doc("${id}").remove()`,
            })
            .then((remo) => {
              if (remo.data.errcode == 0) {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                setTimeout(() => {
                  this.$router.go(0);
                }, 1500);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    //删除操作
    handledelete(e) {
      let token = sessionStorage.getItem("token");

      if (token == "caddGl002") {
        if (this.types == "民品") {
          this.removes("add_data", e);
        } else if (this.types == "汽车") {
          this.removes("car_data", e);
        } else {
          this.removes("house", e);
        }
      } else {
        this.$alert("对不起，您没有该权限", "提示", {
          confirmButtonText: "确定",
        });
      }
    },

    //点击5天的时候
    five(edate) {
      (this.datevalue = dayjs(edate).add(5, "day").format("YYYY-MM-DD")), //点击续当周期，计算出新的结束日期
        (this.xdate = Number(this.ydays) + Number(5)), //计算新的典当天数
        (this.xzdate = "5");

      if (this.xstas == true) {
        //逾期
        return (
          (this.form.pris = Math.trunc(this.xudata.price * 0.007)), //逾期续当综合费
          (this.lx = Math.trunc(this.xudata.price * 0.0005)), //典当利息
          (this.yspri =
            Number(Math.trunc(this.xudata.price * 0.007)) +
            Number(Math.trunc(this.xudata.price * 0.0005)))
        ); //应收
      }
      //未逾期
      (this.form.pris = Math.trunc(this.xudata.price * 0.007)), //续当综合费
        (this.lx = Math.trunc(this.xudata.price * 0.0005)); //典当利息
      this.yspri =
        Number(Math.trunc(this.xudata.price * 0.007)) +
        Number(Math.trunc(this.xudata.price * 0.0005)); //逾期应收
    },

    //点击7天的时候
    seven(edate) {
      (this.datevalue = dayjs(edate).add(7, "day").format("YYYY-MM-DD")), //点击续当周期，计算出新的结束日期
        (this.xdate = Number(this.ydays) + Number(7)), //计算累计的典当天数
        (this.xzdate = "7"); //续当天数

      if (this.xstas == true) {
        //逾期
        return (
          (this.form.pris = Math.trunc(this.xudata.price * 0.0098)), //逾期续当综合费
          (this.lx = Math.trunc(this.xudata.price * 0.0002)), //典当利息,
          (this.yspri =
            Number(Math.trunc(this.xudata.price * 0.0098)) +
            Number(Math.trunc(this.xudata.price * 0.0002)))
        ); //应收
      }
      //未逾期
      (this.form.pris = Math.trunc(this.xudata.price * 0.0098)), //续当综合费
        (this.lx = Math.trunc(this.xudata.price * 0.0002)), //典当利息
        (this.yspri =
          Number(Math.trunc(this.xudata.price * 0.0098)) +
          Number(Math.trunc(this.xudata.price * 0.0002)));
    },

    //点击15天的时候
    thfive(edate) {
      (this.datevalue = dayjs(edate).add(15, "day").format("YYYY-MM-DD")),
        (this.xdate = Number(this.ydays) + Number(15)),
        (this.xzdate = "15");

      if (this.xstas == true) {
        //逾期
        return (
          (this.form.pris = Math.trunc(this.xudata.price * 0.021)), //逾期典当综合费
          (this.lx = Math.trunc(this.xudata.price * 0.0015)), //逾期利息
          (this.yspri =
            Number(Math.trunc(this.xudata.price * 0.021)) +
            Number(Math.trunc(this.xudata.price * 0.0015))) //应收
        );
      }
      //未逾期
      (this.form.pris = Math.trunc(this.xudata.price * 0.015)),
        (this.lx = 0),
        (this.yspri = Math.trunc(this.xudata.price * 0.015));
    },
    // //点击25天的时候
    twufive(edate) {
      (this.datevalue = dayjs(edate).add(25, "day").format("YYYY-MM-DD")),
        (this.xdate = Number(this.ydays) + Number(25)),
        (this.xzdate = "25");

      if (this.xstas == true) {
        //逾期
        return (
          (this.form.pris = Math.trunc(this.xudata.price * 0.035)), //逾期典当综合费
          (this.lx = Math.trunc(this.xudata.price * 0.0025)), //逾期利息
          (this.yspri =
            Number(Math.trunc(this.xudata.price * 0.035)) +
            Number(Math.trunc(this.xudata.price * 0.0025)))
        ); //应收
      }

      //未逾期
      (this.form.pris = Math.trunc(this.xudata.price * 0.02)),
        (this.lx = 0),
        (this.yspri = Math.trunc(this.xudata.price * 0.02)); //应收
    },
    //点击30天的时候
    thre(edate) {
      (this.datevalue = dayjs(edate).add(30, "day").format("YYYY-MM-DD")),
        (this.xdate = Number(this.ydays) + Number(30)),
        (this.xzdate = "30");

      if (this.xstas == true) {
        //逾期
        return (
          (this.form.pris = Math.trunc(this.xudata.price * 0.042)), //逾期典当综合费
          (this.lx = Math.trunc(this.xudata.price * 0.003)), //逾期利息
          (this.yspri =
            Number(Math.trunc(this.xudata.price * 0.042)) +
            Number(Math.trunc(this.xudata.price * 0.003))) //应收
        );
      }
      //未逾期
      this.form.pris = Math.trunc(this.xudata.price * 0.024);
      (this.lx = 0), (this.yspri = Math.trunc(this.xudata.price * 0.024)); //应收
    },

    //发短信
    sendSms(event) {
      if (this.types == "民品") {
        this.axios
          .post("/send", {
            params: {
              tel: event.telnumber,
              name: event.name,
              number: event.ticketnumber,
              date: event.enddate,
              price: event.price,
            },
          })
          .then((rs) => {
            if (rs.data[0].Code == "Ok") {
              this.$notify({
                title: "发送成功",
                message: `短信发送成功${rs.data[0].Message}`,
                type: "success",
              });
            }
          });
      } else {
        this.$alert("暂不支持，汽车业务短信通知正在接入中", "提示", {
          confirmButtonText: "确定",
        });
      }
    },

    //汽车取消续当
    //取消评估
    // dialogVpgClose(){
    //   this.dialogVpg = false,
    //   this.pguInput = ""
    // },

    //汽车业务查看分期点击事件
    checkFq(event) {
      this.detail = event;
      this.dialogVisible1 = !this.dialogVisible1;
    },

    //关闭汽车查看分期弹窗
    handleClose() {
      this.dialogVisible1 = false;
    },

    //补打当票
    Prints(event) {
      this.dialogPrint = true;
      this.PrintData = event;
    },
    //关闭补打当票
    handleClosePrint() {
      this.dialogPrint = false;
      this.PrintData = {};
    },

    //查找按钮
    SearchData() {
      if (this.DateInputSearch !== "" && this.DateInputSearch !== null) {
        //开始往下查找,综合费不为空
        if (this.PriceInput !== 0 && this.PriceInput !== "") {
          this.loading = true;
          this.isY = 1; //1代表查找综合费 2代表查找典当单价

          //第一步，先拿到一共有多少数据，除以1000，计算出有多少页
          //第二步，拿到页数循环，请求数据，每次将结果push到新的数组里
          //第三步，将数组赋值给
          this.axios
            .post("/api/tcb/databasecount?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("add_data").where({deta:_.gte("${
                this.DateInputSearch[0] + " 00:00"
              }").and(_.lte("${this.DateInputSearch[1] + " 23:59"}"))}).count()`,
            })
            .then((res) => {
              //如果数据小于1000
              if (res.data.count > 1000) {
                let requeNum = Math.ceil(res.data.count / 1000);

                let newData = [];
                let aNum = [];
                //循环请求数据
                for (let num = 0; num < requeNum; num++) {
                  this.axios
                    .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                      env: `${this.userData.env}`,
                      query: `db.collection("add_data").where({deta:_.gte("${
                        this.DateInputSearch[0] + " 00:00"
                      }").and(_.lte("${
                        this.DateInputSearch[1] + " 23:59"
                      }"))}).limit(1000).skip(${num * 1000}).get()`,
                    })
                    .then((re) => {
                      re.data.data.forEach((element, index, array) => {
                        array[index] = JSON.parse(element);
                      });
                      //过滤出符合条件的数据
                      let a = re.data.data.filter((item) => {
                        return item.cost >= Number(this.PriceInput);
                      });
                      // console.log(a.length);

                      //拿到每次请求的数组长度push到一个新的数组里
                      aNum.push(a.length);

                      //数据添加到数组

                      newData.push(...a);

                      // this.Nums = a.length;
                    });
                }

                this.items = newData;
                this.FilterItemData = newData;
                this.Ns = aNum;
                // this.Nums = newData.length;
                this.loading = false;

                setTimeout(() => {
                  this.sums();
                }, 4000);
              } else {
                //直接查找1000条数据
                this.axios
                  .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                    env: `${this.userData.env}`,
                    query: `db.collection("add_data").where({deta:_.gte("${
                      this.DateInputSearch[0] + " 00:00"
                    }").and(_.lte("${
                      this.DateInputSearch[1] + " 23:59"
                    }"))}).limit(1000).get()`,
                  })
                  .then((re) => {
                    re.data.data.forEach((element, index, array) => {
                      array[index] = JSON.parse(element);
                    });
                    //直接将数据赋值给数组
                    let a = re.data.data.filter((item) => {
                      return item.cost >= Number(this.PriceInput);
                    });

                    this.Nums = a.length;
                    this.items = a;
                    this.FilterItemData = a;
                    this.loading = false;
                  });
              }
            });

          // this.axios
          //   .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          //     env: `${this.userData.env}`,
          //     query: `db.collection("add_data").where({deta:_.gte("${
          //       this.DateInputSearch[0] + " 00:00"
          //     }").and(_.lte("${
          //       this.DateInputSearch[1] + " 23:59"
          //     }"))}).limit(1000).skip(${event}).get()`,
          //   })
          //   .then((res) => {
          //     res.data.data.forEach((element, index, array) => {
          //       array[index] = JSON.parse(element);
          //     });

          //     let a = res.data.data.filter((item) => {
          //       return item.cost >= Number(this.PriceInput);
          //     });

          //     this.pageNum = res.data.pager.Total;
          //     this.Nums = a.length;
          //     this.items = a;
          //     this.loading = false;
          //   });

          //典当单价为空，综合费不为空
        } else {
          //综合费为空,判断典当单价是否为空

          this.$message.error("请输入查询的综合费");
        }
      } else {
        //没有日期，则提示无日期
        this.$message.error("请先选择要查询的日期");
      }
    },

    //典当单价查找
    SearchDj() {
      //日期不能为空
      if (this.DateInputSearch !== "" && this.DateInputSearch !== null) {
        //如果典当单价不为空
        if (this.PriceDj !== 0 && this.PriceDj !== "") {
          this.isY = 2;
          this.loading = true;

          //单价
          this.axios
            .post("/api/tcb/databasecount?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: `db.collection("add_data").where({deta:_.gte("${
                this.DateInputSearch[0] + " 00:00"
              }").and(_.lte("${this.DateInputSearch[1] + " 23:59"}"))}).count()`,
            })
            .then((res) => {
              //如果数据大于1000
              if (res.data.count > 1000) {
                let requeNum = Math.ceil(res.data.count / 1000);

                let newData = [];
                let aNum = [];
                //循环请求数据
                for (let num = 0; num < requeNum; num++) {
                  this.axios
                    .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                      env: `${this.userData.env}`,
                      query: `db.collection("add_data").where({deta:_.gte("${
                        this.DateInputSearch[0] + " 00:00"
                      }").and(_.lte("${
                        this.DateInputSearch[1] + " 23:59"
                      }"))}).limit(1000).skip(${num * 1000}).get()`,
                    })
                    .then((re) => {
                      re.data.data.forEach((element, index, array) => {
                        array[index] = JSON.parse(element);
                      });
                      //过滤出符合条件的数据
                      let a = re.data.data.filter((item) => {
                        return item.price / item.weight <= Number(this.PriceDj);
                      });
                      // console.log(a.length);

                      //拿到每次请求的数组长度push到一个新的数组里
                      aNum.push(a.length);

                      //数据添加到数组

                      newData.push(...a);

                      // this.Nums = a.length;
                    });
                }
                this.items = newData;
                this.FilterItemData = newData;
                this.Ns = aNum;
                // this.Nums = newData.length;
                this.loading = false;

                setTimeout(() => {
                  this.sums();
                }, 4000);
              } else {
                //直接查找1000条数据
                this.axios
                  .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                    env: `${this.userData.env}`,
                    query: `db.collection("add_data").where({deta:_.gte("${
                      this.DateInputSearch[0] + " 00:00"
                    }").and(_.lte("${
                      this.DateInputSearch[1] + " 23:59"
                    }"))}).limit(1000).get()`,
                  })
                  .then((re) => {
                    re.data.data.forEach((element, index, array) => {
                      array[index] = JSON.parse(element);
                    });
                    //直接将数据赋值给数组
                    let a = re.data.data.filter((item) => {
                      return item.price / item.weight <= Number(this.PriceDj);
                    });
                    this.Nums = a.length;
                    this.items = a;
                    this.FilterItemData = a;
                    this.loading = false;
                  });
              }
            });

          // //
          // this.axios
          //   .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          //     env: `${this.userData.env}`,
          //     query: `db.collection("add_data").where({deta:_.gte("${
          //       this.DateInputSearch[0] + " 00:00"
          //     }").and(_.lte("${
          //       this.DateInputSearch[1] + " 23:59"
          //     }"))}).limit(1000).skip(${event}).get()`,
          //   })
          //   .then((res) => {
          //     res.data.data.forEach((element, index, array) => {
          //       array[index] = JSON.parse(element);
          //     });

          //     let b = res.data.data.filter((item) => {
          //       return item.price / item.weight >= Number(this.PriceDj);
          //     });
          //     this.pageNum = res.data.pager.Total;
          //     this.Nums = b.length;
          //     this.items = b;
          //     this.loading = false;
          //   });

          return;
        }
        //典当单价为空
        this.$message.error("请输入查询的单价");
      } else {
        this.$message.error("请先选择要查询的日期");
      }
    },

    //页码跳转
    currentData(event) {
      let num = (event - 1) * 1000;
      if (this.isY == 1) {
        //请求综合费函数
        this.SearchData(num);
      } else {
        //请求典当单价函数
        this.SearchDj(num);
      }
    },
    //计算求和
    sums() {
      let newNum = 0;
      this.Ns.forEach((item) => {
        return (newNum += item);
      });
      this.Nums = newNum;
    },

    //导出数据
    ExportData() {
      if (this.isY == 0) {
        this.$message({
          message: "请先查找数据在导出",
          type: "warning",
        });
      }
    },
    //过滤数据
    ZData(event) {
      this.items = this.FilterItemData.filter((item) => {
        return item.state == event;
      });
    },
  },
  created() {
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //获取到this.ACCESS_TOKEN
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();

    //获取到今天的日期
    this.deta = dayjs().format("YYYY-MM-DD");
    //逾期、绝当鉴定日期
    this.day = dayjs().subtract(5, "day").format("YYYY-MM-DD");
  },
  mounted() {
    setTimeout(() => {
      this.name = this.userData.username;
    }, 800);
  },
};
</script>
<style scoped>
.ces {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
/* 绝当样式 */
.el-table >>> .warning-row {
  background: #fa9393;
}
/* 逾期样式 */
.el-table >>> .success-row {
  background: #f5eb94;
}
.el-table >>> .sudatas-row {
  background: #66ca90;
}
.yus {
  color: #fce300;
  margin: 0 20px;
}
.jus {
  color: #fa9393;
  margin-right: 60px;
}
.blue {
  margin: 0 10px;
  color: #66ca90;
}
.bj {
  float: left;
}
.con_top {
  width: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.con_query {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 80%;
}
.cont_input {
  width: 25%;
}
.ctens {
  display: flex;
  flex-direction: column;
}
.ctens span {
  margin: 12px 0;
}
.filtrate_sx {
  margin: 10px auto;
  width: 100%;
  height: 100%;
  background: #ffffff;
}
.zhf_input {
  width: 35%;
}
.jls {
  float: right;
}
.rows_header {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
</style>
